import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderService } from 'app/modules/shared/components/loader/loader.service';
import { AccessProviderDirective } from 'app/modules/shared/directives/access-provider.directive';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { PermissionAccessService } from 'app/modules/shared/services/permission-access.service';
import * as _ from 'lodash';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TabViewModule } from 'primeng/tabview';
import { forkJoin } from 'rxjs';
import { AppIcons } from '../../../shared/app.icons';
import { AppSettings } from '../../../shared/app.settings';
import { MITableComponent } from '../../../shared/components/mi-table/mi-table.component';
import { ModuleHeaderComponent } from '../../../shared/components/module-header/module-header.component';
import type { Column } from '../../../shared/models/attribute.models';
import type { Country } from '../../../shared/models/country';
import type { EntityList } from '../../../shared/models/entity.models';
import type { Language } from '../../../shared/models/language';
import { CommonBindingDataService } from '../../../shared/services/common-binding-data.service';
import { ConfigService } from '../../../shared/services/config.service';
import { UserManagementService } from '../../services/user-management.service';
import {
  BulkActionData,
  UserActionData,
  UserTableData,
  UserSearchResponse,
  Pagination,
  ColumnDefinition,
  FilterField,
  AttributeData,
  BulkUpdateEvent,
  BulkActionResponse,
  FilterEvent,
  PageChangeEvent,
  RowSelectEvent
} from '../../models/user-management';
import { Datum } from '../../../shared/models/listResponse.models';
import { ListResponse } from '../../../shared/models/listResponse.models';
import { JsonPipe, TitleCasePipe } from '@angular/common';
interface UserEntityList extends EntityList {
  roleName?: string[];
  userType?: any[];
  typeId?: any[];
}

@Component({
  selector: 'app-manage-user',
  templateUrl: './manage-user.component.html',
  styleUrl: "./manage-user.component.scss",
  standalone: true,
  imports: [TabViewModule, TranslateModule, MITableComponent, BreadcrumbModule, ModuleHeaderComponent, AccessProviderDirective, TitleCasePipe, JsonPipe],
  providers: [TitleCasePipe]
})
export class ManageUserComponent implements OnInit {
  @ViewChild(MITableComponent) tableRef: MITableComponent;
  activeIndex: number = 0;
  isLoading = true;
  filterAvailableColumns: ColumnDefinition[] = [];
  cols: ColumnDefinition[] = [];
  @Input() moduleName: string;
  value: number = 50;
  btnLabel: string;
  items: MenuItem[] | undefined;
  isShowMenu: boolean = true;
  attributeLabels: Record<string, string> = {};
  attributeLabelsData: Record<string, unknown> = {};
  filterAttributeLabels: Record<string, string>;
  labelData = {
    attributeLabels: [
      { labelKey: 'manage_users_grid.fields.userType.label', labelValue: 'User Type' },
      { labelKey: 'manage_users_grid.fields.userType.placeholder', labelValue: 'User Type' },
      { labelKey: 'manage_users_grid.fields.Parent.label', labelValue: 'Parent' },
      { labelKey: 'manage_users_grid.fields.Status.label', labelValue: 'Status' }
    ]
  };
  allColumns: ColumnDefinition[];
  pagination: Pagination;
  totalRecords: number = 0;
  tableData: UserTableData[] = [];
  buttons: MenuItem[] = [];
  country: Country;
  language: Language;
  entityData: UserEntityList = {
    actionStatus: "",
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: "",
    filters: [],
    countryCode: '',
    deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
    forTenantCode: "",
    defaultSortColumn: "updatedAt",
    defaultSortType: "desc",
    status: 'both',

  };
  routePath: MenuItem[] = [];
  home: MenuItem = {};
  isModal: boolean = false;
  selectedColumns!: Column[];
  attributeData: AttributeData;
  data: unknown;
  rowItems: MenuItem[] | undefined;
  bulkSelectionsItems: MenuItem[] | undefined;
  moduleHeaderSecondaryBtnMenuItems: MenuItem[] = [];
  columnsData: unknown;
  bulkDeleteLabel: string = this.cs.getLabel('manage_users.delete');
  bulkUpdateLabel: string = this.cs.getLabel('manage_users.lbl_update_user');
  bulkUpdateHeader: string;
  reviewHeader: string;
  entityNameToDisplay: string;
  btnUpdate: string;
  deleteRoleHeaderMsg: string;
  deleteRoleMsg: string;
  showBulkUpdateDialog: boolean = false;
  visible: boolean = false;
  filterFieldsArray: FilterField[];
  uniqueId: string = 'manage_users_grid';
  isEntity: boolean = false;
  entityName: string;
  currentRow: UserTableData;
  filterList: FilterField[];
  entityDataForRole: UserEntityList = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: "",
    filters: [],
    countryCode: '',
    deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
    forTenantCode: '',
    actionStatus: '',
    status: 'both',
  };
  miIcons = AppIcons;
  showImportExportBtn: boolean = false;
  userStatus: boolean;

  constructor(
    private router: Router,
    private userManagementService: UserManagementService,
    private cs: CommonBindingDataService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private configService: ConfigService,
    private permissionAccessService: PermissionAccessService,
    private loaderService: LoaderService,
    private entityService: EntityService,
    private titleCase: TitleCasePipe
  ) { }

  ngOnInit() {
    this.setUpRoutePath();
    this.setUpRowItems();
    this.setupBulkSelectionsItems();
    this.initializeOtherVariablesAndAPI();
    this.initializeColumn();
  }

  initializeColumn() {
    this.allColumns = [
      {
        "attributeCode": "ID",
        "attributeIndex": 0,
        "field": "userCode",
        "header": this.cs.getLabel('manage_users.columns.lbl_id'),
        "isSortable": true
      },
      {
        "attributeCode": "email",
        "attributeIndex": 1,
        "field": "email",
        "header": this.cs.getLabel('manage_users.columns.lbl_user_email'),
        "isSortable": true
      },
      {
        "attributeCode": "first_name",
        "attributeIndex": 2,
        "isSortable": true,
        "field": "firstName",
        "header": this.cs.getLabel('manage_users.columns.lbl_first_name')
      },
      {
        "attributeCode": "last_name",
        "attributeIndex": 3,
        "isSortable": true,
        "field": "lastName",
        "header": this.cs.getLabel('manage_users.columns.lbl_last_name')
      },
      {
        "attributeCode": "contactNumber",
        "attributeIndex": 4,
        "isSortable": true,
        "field": "contactNumber",
        "header": this.cs.getLabel('manage_users.columns.lbl_phone_number')
      },
      {
        "attributeCode": "user_status",
        "attributeIndex": 5,
        "isSortable": true,
        "field": "active",
        "header": this.cs.getLabel('manage_users.lbl_status')
      },
      {
        "attributeCode": "parent_name",
        "attributeIndex": 6,
        "isSortable": false,
        "field": "parentName",
        "header": this.cs.getLabel('manage_users.columns.lbl_parent')
      },
      {
        "attributeCode": "user_type",
        "attributeIndex": 7,
        "isSortable": false,
        "field": "userType",
        "header": this.cs.getLabel('manage_users.columns.lbl_user_type')
      },
    ];
  }

  initializeOtherVariablesAndAPI() {
    // localStorage.setItem(AppSettings.COUNTRY, '[{"forTenantCode":null,"countryCode":"IN","countryName":"India","active":true,"countryId":"2","tenantId":"2"}]')
    this.btnLabel = this.cs.getLabel('manage_users.lbl_invite_users');
    this.bulkDeleteLabel = this.cs.getLabel('manage_users.message.delete_user');
    this.bulkUpdateLabel = this.cs.getLabel('manage_users.lbl_update_user');
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    // this.country = JSON.parse('[{"forTenantCode":null,"countryCode":"IN","countryName":"India","active":true,"countryId":"2","tenantId":"2"}]');

    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
    this.bulkUpdateHeader = this.cs.getLabel('manage_users.lbl_bulk_update_header');
    this.entityNameToDisplay = this.cs.getLabel('manage_users.lbl_entity_name_display');
    this.btnUpdate = this.cs.getLabel('manage_users.btn_bulk_update');
    this.reviewHeader = this.cs.getLabel('manage_users.lbl_review_users');
    this.deleteRoleMsg = this.cs.getLabel('manage_users.message.confirm_delete_msg');
    this.deleteRoleHeaderMsg = this.cs.getLabel('manage_users.message.delete_user');
    this.getBulkUpdateAttributeData();
    this.getData();
    // this.getUserRoles();
  }

  private setUpRoutePath() {
    this.routePath = [
      { label: this.cs.getLabel('manage_users.lbl_route_users') },
    ];
  }

  private setUpRowItems() {
    const isEdit = this.permissionAccessService.hasAccess('USERS_AND_ROLES', '', 'ALL', 'EDIT');
    const isUpdateStatus = this.permissionAccessService.hasAccess('USERS_AND_ROLES', '', 'ALL', 'ACTIVATE');
    const isDelete = this.permissionAccessService.hasAccess('USERS_AND_ROLES', '', 'ALL', 'DELETE');
    this.rowItems = [
      ...(isEdit ? [{
        label: this.cs.getLabel('manage_users.edit'),
        icon: `${AppIcons.EDIT_2} wh-122`,
        iconClass: 'bulk-update-icon',
        command: () => {
          this.update();
        }
      }] : []),
      ...(isUpdateStatus ? [{
        label: this.cs.getLabel('protocol.lbl_activate'),
        icon: `${AppIcons.CIRCLE_CHECKED} wh-16`,
        iconClass: 'bulk-update-icon',
        value: 'Active',
        command: () => {
          this.makeUserActiveInactive(this.currentRow, true);
        }
      }] : []),
      ...(isUpdateStatus ? [{
        label: this.cs.getLabel('protocol.lbl_deactivate'),
        icon: `${AppIcons.ACTIVATE} wh-16`,
        iconClass: 'bulk-update-icon',
        value: 'Inactive',
        command: () => {
          this.makeUserActiveInactive(this.currentRow, false);
        }
      }] : []),
      ...(isDelete ? [{
        label: this.cs.getLabel('lbl_delete'),
        icon: `${AppIcons.BASIC_TRAY} wh-16`,
        iconClass: 'bulk-update-icon',
        command: () => {
          this.tableRef.delete(AppSettings.DELETE_TYPE.ROW);
        }
      }] : []),
    ];
  }

  private setupBulkSelectionsItems() {
    const isBulkAction = this.permissionAccessService.hasAccess('USER_MANAGEMENT', 'MANAGE_USERS', 'DETAILS', 'BULK_ACTION');
    this.bulkSelectionsItems = [
      ...(isBulkAction ? [{
        label: this.bulkUpdateLabel,
        icon: `${AppIcons.EDIT_2} wh-122`,
        iconClass: 'bulk-update-icon',
        styleClass: 'bulk-update-list',
        command: (e) => {
          if (e.item.label === this.bulkUpdateLabel) {
            this.openBulkUpdateDialog();
          }
        },
      }] : []),
      ...(isBulkAction ? [{
        label: this.bulkDeleteLabel,
        icon: `${AppIcons.BASIC_TRAY} wh-122`,
        iconClass: 'bulk-update-icon',
        styleClass: 'bulk-update-list',
        command: () => {
          this.tableRef.delete(AppSettings.DELETE_TYPE.BULK);
        },
      }] : []),
    ];
  }

  private openBulkUpdateDialog() {
    this.visible = true;
    this.showBulkUpdateDialog = false;
    setTimeout(() => {
      this.showBulkUpdateDialog = true;
      this.tableRef.showBulkRowDialog();
    }, 200);
  }

  getUserRoles() {
    this.entityDataForRole.countryCode = this.country[0].countryCode;
    this.loaderService.hide();
    this.userManagementService.searchEntity(this.entityDataForRole, false).subscribe((res: UserSearchResponse) => {
      const roleNames = res?.data.map(data => data.userType) || [];
      const userRoleFilter = this.filterList.find(filter => filter.attributeCode === 'UserRole');
      if (userRoleFilter) {
        userRoleFilter.presetValues = roleNames.map(roleName => ({
          labelKey: roleName,
          labelValue: roleName,
        }));
      }
    });
  }

  getFilterView() {
    this.filterAttributeLabels = this.cs.getAttributeLabels(this.labelData) as unknown as Record<string, string>;
    this.filterList = [
      {
        "attributeId": null,
        "attributeCode": "userType",
        "attributeIndex": 2,
        "fieldName": "User Type",
        "inputCode": "selectDropdown",
        "presetValues": [
          {
            "labelKey": "Admin",
            "labelValue": "admin",
          },
          {
            "labelKey": "Reviewer",
            "labelValue": "reviewer",
          },
          {
            "labelKey": "Site User",
            "labelValue": "site",
          },
          {
            "labelKey": "Sponsor User",
            "labelValue": "sponsor",
          }
        ],
      },
      {
        "attributeId": null,
        "attributeCode": "Parent",
        "attributeIndex": 2,
        "inputCode": "select",
        "presetValues": [],
        "disabled": true
      },
      {
        "attributeId": null,
        "attributeCode": "Status",
        "attributeIndex": 5,
        "presetValues": [
          {
            "labelKey": "Active",
            "labelValue": "Active",
          },
          {
            "labelKey": "Inactive",
            "labelValue": "Inactive",
          }
        ],
      }
    ];
  }

  getBulkUpdateAttributeData() {
    this.attributeData = {
      tabs: [
        {
          groups: [
            {
              fields: [
                {
                  attributeCode: 'user_status',
                  attributeValue: 'Status',
                  isDisable: false,
                  presetValues: [
                    { labelValue: 'Active', labelKey: 'Active' },
                    { labelValue: 'Inactive', labelKey: 'Inactive' },
                  ]
                }
              ]
            }
          ]
        }
      ]
    };
    this.updateFilterFieldsArray(this.attributeData.tabs[0]?.groups[0]?.fields as unknown as FilterField[]);
  }

  private updateFilterFieldsArray(fields: FilterField[]) {
    if (!fields) return;

    this.filterFieldsArray = [];
    fields.forEach(field => {
      if (field.attributeCode === 'user_status') {
        this.filterFieldsArray.push(field)
      }
    });
  }

  getTableView() {
    this.isLoading = false;
    this.searchEntity();

    this.filterAvailableColumns = _.clone(this.allColumns);
  }

  getData() {
    return forkJoin({
      tableViewData: this.getTableView(),
      filterViewDate: this.getFilterView(),
    })
  }

  searchEntity() {
    this.tableData = [];
    this.entityData.countryCode = this.country[0].countryCode;
    this.userManagementService.searchEntityUser(this.entityData).subscribe((res: UserSearchResponse) => {
      if (res.data) {
        this.pagination = res?.pagination;
        this.totalRecords = res?.count;

        this.tableData = res?.data.map(data => {
          const fullName = `${data.firstName} ${data.lastName}`;
          const status = data.active ? { Active: 'Active' } : { Inactive: 'Inactive' };
          const userType = this.titleCase.transform(data.userType);
          return {
            id: data.userId,
            ...data,
            fullName,
            active: status,
            userType
          };
        }) || [];
      }
    });
  }

  onSearchValueChanges(event: string) {
    this.entityData.searchStr = event || '';
    this.searchEntity();
  }

  onFilterValueChange(event: FilterEvent) {
    if (event.Status && event.Status.length === 2 && event.Status.includes('Active') && event.Status.includes('Inactive')) {
      this.entityData.status = 'both';
    } else {
      this.entityData.status = event.Status?.toString() ? event.Status.toString() : 'both';
    }

    if (event?.userType !== undefined && event.userType !== null && event.userType) {
      this.entityData.userType = [event.userType];
      const userType = event.userType.toString();
      if (userType === 'site' || userType === 'sponsor') {
        this.cs.emitParentFilterState(userType);
      } else {
        this.cs.emitParentFilterState(null);
      }
    } else {
      this.cs.emitParentFilterState(null);
      delete this.entityData.userType;
    }

    if (event.Parent && event.Parent.length > 0) {
      this.entityData.typeId = event.Parent;
    } else {
      delete this.entityData.typeId
    }

    this.entityData.offset = event.first;
    this.searchEntity();
  }

  setParentOption(entityCode: string) {
    this.filterList[1].presetValues = [];
    this.filterList[1].disabled = false;
    const country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    const requestBody = {
      limit: AppSettings.DROPDOWN_ROLE_LIMIT,
      offset: 0,
      searchStr: "",
      filters: [],
      countryCode: country[0].countryCode,
      deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
      forTenantCode: this.configService.getForTenantCode(),
      actionStatus: '',
      status: "both"
    }
    this.entityService.searchEntity(entityCode, requestBody, false).subscribe((res: ListResponse) => {
      this.filterList[1].presetValues = res.data.map((ele: Datum) => ({
        labelValue: entityCode === AppSettings.ENTITY_CODE.SITE ? ele.values.site_name as string : ele.values.sponsor_name as string,
        labelKey: ele.id
      })).sort((a, b) => {
        const labelA = a.labelValue;
        const labelB = b.labelValue;
        return labelA.toString().localeCompare(labelB.toString());
      });
    })
  }

  onPageChange(event: PageChangeEvent) {
    this.entityData.offset = event?.first;
    this.entityData.limit = event?.rows;
    this.searchEntity();
  }

  itemPerPageChange(event: number) {
    this.entityData.limit = event;
    this.searchEntity();
  }

  update() {
    this.onUpdateUser(this.currentRow.userId);
  }

  onUpdateUser(userId: string) {
    this.router.navigate(['app/manage-users/edit-user'], { queryParams: { id: userId } });
  }

  makeUserActiveInactive(currentRow: UserTableData, isActive: boolean) {
    this.userStatus = isActive;
    const headerMsg = !isActive ? this.cs.getLabel('manage_users.inactive_user_header_message') : this.cs.getLabel('manage_users.active_user_header_message');
    const bodyMsg = !isActive ? this.cs.getLabel('manage_users.inactive_status_message') : this.cs.getLabel('manage_users.active_status_message')
    const acceptLabel = !isActive ? this.cs.getLabel('manage_users.lbl_deactivate') : this.cs.getLabel('manage_users.lbl_activate');
    this.confirmationService.confirm({
      header: headerMsg,
      message: bodyMsg,
      acceptLabel,
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectLabel: this.cs.getLabel('manage_users.cancel'),
      rejectButtonStyleClass: 'bg-white text-color',
      acceptButtonStyleClass: !isActive ? 'bg-red-500' : 'bg-green-500',
      accept: () => {
        this.tableRef.changeStatusOfEntity();
      },
      reject: () => {
      }
    });
  }

  onChangeStatus(currentRow: UserTableData) {
    const requestBody: UserActionData = {
      forTenantCode: this.configService.getForTenantCode(),
      active: this.userStatus.toString()
    };
    this.userManagementService.updateUserActionStatus(currentRow.userId, requestBody).subscribe(() => {
      setTimeout(() => {
        this.searchEntity();
      }, 500);
      if (this.userStatus) {
        this.showSuccessMessage('manage_users.message.msg_user_active');
      } else {
        this.showSuccessMessage('manage_users.message.msg_user_inactive');
      }
    }, error => {
      const errorMsg = error?.errors?.general?.[0]?.message ?? "An unknown error occurred.";
      this.showErrorMessage(errorMsg);
    });
  }

  private showSuccessMessage(labelKey: string) {
    this.messageService.add({
      key: 'tst',
      severity: 'success',
      summary: 'Successful',
      detail: this.cs.getLabel(labelKey),
    });
  }

  private showErrorMessage(labelKey: string) {
    this.messageService.add({
      key: 'tst',
      severity: 'error',
      summary: 'Error',
      detail: this.cs.getLabel(labelKey)
    });
  }

  setCurrentRowData(event: UserTableData) {
    this.currentRow = event;
    const status = Object.entries(event?.active)[0][0];
    this.setEditOptionDisabledForDeletedRecord(status);
  }

  setEditOptionDisabledForDeletedRecord(data: string) {
    this.rowItems.forEach(rowItem => {
      rowItem.disabled = rowItem.value === data;
    })
  }

  onStaticBulkDataUpdate(event: BulkUpdateEvent) {
    const requestBody: BulkActionData = {
      forTenantCode: this.configService.getForTenantCode(),
      active: event.data[0].attributeValue === AppSettings.USERS_STATUS.ACTIVE,
      userIds: event.entityIds
    };
    this.userManagementService.updateBulkUserActionStatus(requestBody).subscribe({
      next: (res: BulkActionResponse) => {
        this.messageService.add({ key: 'tst', severity: 'success', summary: 'Success', detail: res.message });
        this.searchEntity();
      },
      error: (error) => {
        this.messageService.add({ key: 'tst', severity: 'error', summary: 'Error', detail: this.cs.getLabel(error.errors.general[0].messageCode) });
      }
    })
  }

  onBulkDataDeleteEvent(event: string) {
    const requestBody: BulkActionData = {
      forTenantCode: this.configService.getForTenantCode(),
      userIds: [event]
    };
    this.userManagementService.deleteBulkUserActionStatus(requestBody).subscribe({
      next: (res: BulkActionResponse) => {
        this.messageService.add({ key: 'tst', severity: 'success', summary: 'Success', detail: res.message });
        this.searchEntity();
      },
      error: (error) => {
        this.messageService.add({ key: 'tst', severity: 'error', summary: 'Error', detail: this.cs.getLabel(error.errors.general[0].messageCode) });
      }
    })
  }

  onAddUser() {
    this.router.navigate(['app/manage-users/add-user']);
  }

  onRowSelect(event: RowSelectEvent) {
    if (event.type === 'row') {
      const { id } = event.data;
      this.router.navigate(['app/manage-users/user-details'], { queryParams: { id } });
    }
  }

  onSortData(event) {
    this.entityData.defaultSortColumn = event.field;
    this.entityData.defaultSortType = (event.sortOrder === 1) ? AppSettings.ASC_SORT_ORDER : AppSettings.DESC_SORT_ORDER;
    this.searchEntity();
  }
}
